// #region imports

// --- Angular
import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  forwardRef,
  Output,
  EventEmitter,
  Renderer2,
  ViewChild,
  OnChanges,
  SimpleChanges,
  SimpleChange
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

// --- HS Code
import { SelectListItem } from '../../../models';

// #endregion

@Component({
  selector: 'hs-language-select-control',
  templateUrl: './language-select-control.component.html',
  styleUrls: ['./language-select-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LanguageSelectControlComponent),
      multi: true
    }
  ]
})
export class LanguageSelectControlComponent implements OnInit, ControlValueAccessor {
  @Input() name: string;
  @Input() languages: SelectListItem[];
  @Input() controlId: string;

  @Output() valueChange = new EventEmitter<string>();
  @Output() lostFocus = new EventEmitter();

  @ViewChild('ddllanguageValue', { static: true }) ddllanguageValue;

  onChange: (arg0: string) => void;
  onTouched: () => void;

  validationMessage: string;

  selectedValue: string;

  constructor(private renderer: Renderer2) {}

  ngOnInit() {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    const select = this.ddllanguageValue.nativeElement;
    this.renderer.setProperty(select, 'disabled', isDisabled);
  }

  writeValue(value: string): void {
    if (this.languages) {
      const selectedValue = this.languages.find(v => v.value === value);
      if (selectedValue) {
        selectedValue.isSelected = true;
      }
    }
    this.selectedValue = value;
  }

  onLanguageChanged(languageId: string): void {
    if (this.onChange && typeof this.onChange === 'function') {
      this.onChange(languageId);
    }
    this.valueChange.emit(languageId);
  }

  onFocus(): void {
    if (this.onTouched && typeof this.onTouched === 'function') {
      this.onTouched();
    }
  }

  onBlur(): void {
    this.lostFocus.emit(this);
  }
}
